














































import Vue, { VueConstructor } from 'vue';
import {mock} from 'mockjs';
import { menuRouter } from '../../src/';

export default Vue.extend({
    methods: {
        push() {
            menuRouter.ready(() => {
                this.$menuRouter.push(window.location.href);
            });
        },
        push1() {
            menuRouter.ready(() => {
                this.$menuRouter.push(window.location.href, {
                    mock: mock({
                        'list|1-10': [{
                            // 属性 id 是一个自增数，起始值为 1，每次增 1
                            'id|+1': 1
                        }]
                    })
                }, {
                    title: '测试'
                });
            });
        },
        open() {
            menuRouter.ready(() => {
                const targetWindow = menuRouter.open(window.location.href, {
                    mock: mock({
                        'list|1-10': [{
                            // 属性 id 是一个自增数，起始值为 1，每次增 1
                            'id|+1': 1
                        }]
                    })
                }, {
                    title: '测试',
                    // switchTab: 'PC-GATHER-QCZJ-LEADS',
                    // activeMenu: 'dashboard'
                });
                targetWindow && targetWindow.onClose(() => {
                    console.log('接收到打开窗口的 close 事件')
                });
            });
        },
        close() {
            menuRouter.ready(() => {
                menuRouter.close({ noticeSourceWindow: true });
            });
        },
        onClose() {
            menuRouter.ready(() => {
                menuRouter.onClose((done) => {
                    const ret = confirm('确认关闭吗');
                    if (ret) {
                        done();
                    }
                });
            });
        },
        getSelectedShop() {
            menuRouter.ready((res) => {
                menuRouter.getSelectedShop().then((res) => {
                    console.log('getSelectedShop', res);
                });
            });
        },
        getAuthZ() {
            menuRouter.ready((res) => {
                menuRouter.getAuthZ().then((res) => {
                    console.log('getAuthZ', res);
                });
            });
        },
        getPayload() {
            menuRouter.ready((res) => {
                console.log('getPayload', res);
            });
        },
        setTitle() {
            menuRouter.ready((res) => {
                menuRouter.title('已修改');
            });
        },
        activeMenu() {
            menuRouter.ready((res) => {
                menuRouter.activeMenu('PC-GATHER-QCZJ-LEADS');
            });
        }
    }
});
